var _g, _g2, _g3, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_503_4937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 25H9C7.89543 25 7 25.8954 7 27V33C7 34.1046 7.89543 35 9 35H12C13.1046 35 14 34.1046 14 33V27C14 25.8954 13.1046 25 12 25Z",
    fill: "#D49EFF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 25.5H12.25C12.9636 25.5 13.5 26.0451 13.5 26.6667V33.3333C13.5 33.9549 12.9636 34.5 12.25 34.5H8.75C8.03638 34.5 7.5 33.9549 7.5 33.3333V26.6667C7.5 26.0451 8.03638 25.5 8.75 25.5Z",
    stroke: "url(#paint0_linear_503_4937)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_503_4937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 21H19C17.8954 21 17 21.8954 17 23V33C17 34.1046 17.8954 35 19 35H22C23.1046 35 24 34.1046 24 33V23C24 21.8954 23.1046 21 22 21Z",
    fill: "#D49EFF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 21.5H22.25C22.9788 21.5 23.5 22.0363 23.5 22.6154V33.3846C23.5 33.9637 22.9788 34.5 22.25 34.5H18.75C18.0212 34.5 17.5 33.9637 17.5 33.3846V22.6154C17.5 22.0363 18.0212 21.5 18.75 21.5Z",
    stroke: "url(#paint1_linear_503_4937)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_503_4937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 17H29C27.8954 17 27 17.8954 27 19V33C27 34.1046 27.8954 35 29 35H32C33.1046 35 34 34.1046 34 33V19C34 17.8954 33.1046 17 32 17Z",
    fill: "#D49EFF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.75 17.5H32.25C32.9871 17.5 33.5 18.0318 33.5 18.5882V33.4118C33.5 33.9682 32.9871 34.5 32.25 34.5H28.75C28.0129 34.5 27.5 33.9682 27.5 33.4118V18.5882C27.5 18.0318 28.0129 17.5 28.75 17.5Z",
    stroke: "url(#paint2_linear_503_4937)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2319 4.25C22.8177 4.25 22.4819 4.58579 22.4819 5C22.4819 5.41421 22.8177 5.75 23.2319 5.75H27.2183L19.7536 13.2147L15.6463 9.10735C15.5056 8.9667 15.3149 8.88768 15.1159 8.88768C14.917 8.88768 14.7263 8.9667 14.5856 9.10735L8.78852 14.9045C8.49562 15.1973 8.49562 15.6722 8.78852 15.9651C9.08141 16.258 9.55628 16.258 9.84918 15.9651L15.1159 10.6983L19.2233 14.8057C19.364 14.9463 19.5547 15.0254 19.7536 15.0254C19.9525 15.0254 20.1433 14.9463 20.284 14.8057L28.279 6.81062V10.7971C28.279 11.2113 28.6148 11.5471 29.029 11.5471C29.4432 11.5471 29.779 11.2113 29.779 10.7971V5C29.779 4.88046 29.7511 4.76744 29.7013 4.66715C29.6765 4.61712 29.6458 4.56928 29.6092 4.52468C29.536 4.43546 29.4427 4.36342 29.3361 4.31554C29.2424 4.27343 29.1384 4.25 29.029 4.25H23.2319Z",
    fill: "#A93EC1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_503_4937",
    x: 7,
    y: 25,
    width: 7,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.619608 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_503_4937"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_503_4937",
    x: 17,
    y: 21,
    width: 7,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.619608 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_503_4937"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_503_4937",
    x: 27,
    y: 17,
    width: 7,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.619608 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_503_4937"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_503_4937",
    x1: 6.41667,
    y1: 24.4444,
    x2: 14.3721,
    y2: 33.8088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D49EFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49EFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_503_4937",
    x1: 16.4167,
    y1: 20.4615,
    x2: 27.2458,
    y2: 29.8555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D49EFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49EFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_503_4937",
    x1: 26.4167,
    y1: 16.4706,
    x2: 39.3189,
    y2: 25.3245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D49EFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49EFF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChart);
export default __webpack_public_path__ + "static/media/icon-chart.09f6aa8f3f32c5c65a4a237fc6a33bfc.svg";
export { ForwardRef as ReactComponent };